import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ApModal from "../../../components/Modal/ApModal";
import FormAction from "../../../components/Actions/FormAction";
import ItemWhTable from "../../../components/Content/ItemWhTable";

// Model
import { whDocMasterModel } from "../../../../model/Warehouse/WHDocMasterModel";
import { whDocDetailModel } from "../../../../model/Warehouse/WHDocDetailModel";

import {
  getDataWithComp,
  getViewAp,
  formatCurrency,
  getAlert,
  getMaxTnsNo,
  randomDelay,
  parseCurrency,
  getDataWithJoin,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatDateOnChange,
  formatStringDateToDate,
  formatThaiDateUiToDate,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";

const FormTransfer = ({ callInitialize, mode, name, whDocNo }) => {
  const [formMasterList, setFormMasterList] = useState(whDocMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  console.debug("formDetailList", formDetailList);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);

  // การเลือกคลังจากหน้าจอ
  const [selectedWarehouseFrom, setSelectedWarehouseFrom] = useState(null);
  const [selectedWarehouseTo, setSelectedWarehouseTo] = useState(null);

  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const whDataList = await getDataWithComp(
      "Tb_Set_WH",
      ` AND WH_Status = 'Y' ORDER BY  WH_Name ASC`
    );
    if (whDataList && whDataList.length > 0) {
      setWhDataList(whDataList);
    }

    const apDataList = await getViewAp();
    if (apDataList && apDataList.length > 0) {
      setApDataList(apDataList);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeWarehouse = async (value, type) => {
    if (type === "FROM") {
      setFormDetailList([]);

      const whId = parseCurrency(value);
      const companyId = localStorage.getItem("company");

      console.debug("🔍 Loading warehouse items:", { whId, companyId });

      try {
        const data = await getDataWithJoin(
          `
          v.Item_Id, v.Item_Barcode, v.Item_Code, 
          v.Item_Name, v.Item_Name_EN, v.Item_Short_Name, 
          v.Item_Unit_IN, v.Item_Unit_ST, v.Item_Unit_OUT, 
          v.Item_Cost, v.Item_Price, v.Item_PriceA, v.Item_PriceB, 
          v.Item_Brand, v.Item_Series, v.Item_Colour, v.Size_Line,
          ISNULL(wh.Item_Onhand, 0) AS Item_Onhand
        `,
          `View_Set_Item v`,
          `
          LEFT JOIN Tb_Set_ItmGroup grp ON (grp.Group_Id = v.Item_Group)
          ${
            whId
              ? `LEFT JOIN (
            SELECT wh.*, ROW_NUMBER() OVER (PARTITION BY wh.Item_Id ORDER BY wh.Item_Onhand DESC) AS rn
            FROM API_1101_WH_ITEM_ONHAND wh
            WHERE wh.WH_Id = ${whId}
          ) wh ON (wh.Item_Id = v.Item_Id AND wh.rn = 1)`
              : ""
          }
        `,
          `
          WHERE v.Comp_Id = ${companyId} 
          AND grp.Comp_Id = ${companyId}
          AND grp.Group_Code = 'G'
          AND ISNULL(v.is_Active, v.Item_Status) = 'Y'
          ORDER BY v.Item_Short_Name, v.Item_Brand, v.Item_Series, v.Item_Colour, v.Size_Line
        `
        );

        console.debug("✅ Data loaded:", data?.length, "items");
        console.debug("Sample item:", data?.[0]);

        if (data && data.length > 0) {
          setItemDataList(data);
        } else {
          console.warn("⚠️ No items found for warehouse:", whId);
        }
      } catch (error) {
        console.error("❌ Error loading warehouse items:", error);
        alert(`เกิดข้อผิดพลาด: ${error.message || error}`);
      }

      setSelectedWarehouseFrom(value);
    } else {
      setSelectedWarehouseTo(value);
    }
  };

  const handleQuantityChange = (index, type, value, onHand) => {
    // ดักค่าเพื่อให้ส่งมาอย่างถูกต้อง (จริงๆแล้วแทบไม่ได้ใช้)
    if (type !== "decrease") {
      getAlert("FAILED", "พบข้อผิดพลาดในการดำเนินการ กรุณารีเฟชรแล้วลองใหม่");
    }

    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    // หากผู้ใช้กรอกจุดทศนิยมอย่างเดียว (เช่น ".") ให้คงค่าเดิมไว้ก่อน
    if (value === ".") {
      const updatedList = [...formDetailList];
      updatedList[index].itemDecrease = value;
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    const updatedList = [...formDetailList];

    // ดักไม่ให้ปรับปรุงเกินกว่าสินค้าคงเหลือ เฉพาะตอนปรับลดสินค้า
    if (value > onHand) {
      getAlert("FAILED", "กรุณาระบุจำนวนไม่เกินคงเหลือ");
      updatedList[index].itemDecrease = null;
      updatedList[index].docType = null;
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    updatedList[index].docType = "TO";
    updatedList[index].itemDecrease = value;
    updatedList[index].itemQty = parseCurrency(value);
    updatedList[index].itemBalance =
      parseCurrency(onHand) - parseCurrency(value);

    setFormDetailList(updatedList);
  };

  const handleFocus = (index) => {
    const updatedList = [...formDetailList];
    console.debug(updatedList);
    updatedList[index].itemDecrease =
      parseCurrency(updatedList[index].itemDecrease) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease = formatCurrency(
      updatedList[index].itemDecrease
    );
    setFormDetailList(updatedList);
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        whDocCustId: apSelected.AP_Id,
        whDocCustCode: apSelected.AP_Code,
        whDocCustName: apSelected.AP_Name,
      });
      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      // ใช้ Set เพื่อกรอง Item_Id ที่ซ้ำกัน
      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => {
        return itemsSelected.find((item) => item.Item_Id === id);
      });

      // อัปเดตรายการโดยคงค่าของสินค้าที่เคยมีอยู่
      const updatedFormDetailList = uniqueItems.map((itemSelected) => {
        // ค้นหาว่ามีสินค้าอยู่ใน formDetailList เดิมหรือไม่
        const existingItem = formDetailList.find(
          (item) => item.itemId === itemSelected.Item_Id
        );

        return {
          line: existingItem?.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: existingItem
            ? formatCurrency(existingItem.itemQty || 0)
            : formatCurrency(0),
          itemDecrease: existingItem
            ? formatCurrency(existingItem.itemDecrease || 0)
            : formatCurrency(0),
          itemUnit: existingItem
            ? existingItem.itemUnit
            : itemSelected.Item_Unit_ST,
          itemOnHand: itemSelected.Item_Onhand || 0,
          itemBalance: itemSelected.Item_Onhand || 0,
          itemPriceUnit: 0,
          itemTotal: 0,
          docType: null,
          itemIsReturn: null,
          itemReturnDate: null,
        };
      });

      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = (index) => {
    const newList = formDetailList.filter((_, i) => i !== index);
    setFormDetailList(newList);
  };

  const handleUploadAttachments = async (whDocId) => {
    const pendingFiles = selectedFiles.filter((file) => file.isPending);
    if (pendingFiles.length === 0) return;

    try {
      const filesWithBase64 = pendingFiles.map((file) => ({
        id: file.id,
        name: file.name,
        type: file.type,
        size: file.size,
        dataUrl: file.dataUrl,
        isPending: true,
        displayName: file.name,
      }));

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/upload-file`,
        {
          comp_id: localStorage.getItem("company"),
          doc_id: whDocId,
          DocCode_ID: 17, // รหัสประเภทเอกสาร ปรับตามระบบ
          upload_by: localStorage.getItem("name") || "system",
          file_status: "Y",
          files: filesWithBase64,
          doc_no_ref: null,
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        setSelectedFiles((prev) =>
          prev
            .filter((file) => !file.isPending)
            .concat(
              response.data.files.map((file) => ({
                F_Id: file.File_Id,
                fileName: file.fileName,
                File_Url: file.fileUrl,
                uploadDate: file.uploadDate,
                uploadBy: file.uploadBy,
              }))
            )
        );
        // getAlert("OK", "อัปโหลดไฟล์สำเร็จ");
      } else {
        throw new Error(response.data.message || "การอัปโหลดล้มเหลว");
      }
    } catch (error) {
      console.error("UPLOAD ERROR:", error);
      getAlert("FAILED", `การอัปโหลดไฟล์ล้มเหลว: ${error.message}`);
    }
  };

  const handleSubmit = async () => {
    try {
      if (!selectedFiles || selectedFiles.length === 0) {
        getAlert("FAILED", "กรุณาแนบไฟล์ก่อนทำการบันทึก");
        return;
      }

      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const findMaxTnsNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '2' ORDER BY WHDoc_No DESC`
      );
      const maxTns = getMaxTnsNo(findMaxTnsNo);
      let newMaxTns = maxTns;

      if (selectedWarehouseFrom === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return;
      }
      if (selectedWarehouseTo === null) {
        getAlert("FAILED", "กรุณาเลือกไปคลัง");
        return;
      }

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      // if (!formMasterList.whDocCustId) {
      //     getAlert("FAILED", "กรุณาเลือกผู้ขาย");
      //     return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      // }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะปรับปรุง");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert(
            "FAILED",
            `กรุณากรอกจำนวนปรับปรุงของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: newMaxTns,
        wh_doc_type: parseCurrency("2", 10),
        wh_doc_cust_id: parseCurrency(formMasterList.whDocCustId, 10),
        wh_doc_date: formatStringDateToDate(formMasterList.whDocDate),
        wh_doc_trans_date: formatStringDateToDate(
          formMasterList.whDocTransDate
        ),
        wh_doc_created_date: formatThaiDateUiToDate(
          formMasterList.whDocCreatedDate
        ),
        wh_doc_created_by: formMasterList.whDocCreatedBy,
        wh_doc_status: parseCurrency("1", 10),
        wh_doc_seq: formatDateTime(new Date()),
        wh_doc_remark: formMasterList.whDocRemark,
        wh_doc_comp_id: formMasterList.whDocCompId,
        wh_doc_show_front: null,
        ref_doc_id: formMasterList.refDocId,
        f_wh_id: selectedWarehouseFrom,
        t_wh_id: selectedWarehouseTo,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const getWhDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-wh-doc-no`,
          {
            table: "WHDoc_H",
            wh_doc_no: formMasterData.wh_doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        if (getWhDocIdResponse && getWhDocIdResponse.data.length > 0) {
          const whDocId = parseCurrency(
            getWhDocIdResponse.data[0].WHDoc_Id,
            10
          );

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              wh_doc_id: whDocId,
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_total: parseCurrency(item.itemTotal),
              doc_type: item.docType,
              f_wh_id: selectedWarehouseFrom,
              f_zone_id: item.fZoneId,
              f_lt_id: item.fLtId,
              t_wh_id: selectedWarehouseTo,
              t_zone_id: item.fZoneId,
              t_lt_id: item.fLtId,
              ref_doc_id: item.refDocId,
              item_is_return: item.itemIsReturn,
              item_return_date: item.itemReturnDate,
            };

            // ย้ายออก
            await manageWhItemData(
              item.itemId,
              item.itemCode,
              item.itemName,
              selectedWarehouseFrom,
              "TO",
              parseCurrency(item.itemQty),
              whDocId,
              newMaxTns,
              item.itemOnHand === 0 ? "เริ่มต้นประวัติคลัง" : newMaxTns, // 👈 เพิ่มเงื่อนไข
              formMasterList.whDocRemark
            );

            // ย้ายเข้า
            await manageWhItemData(
              item.itemId,
              item.itemCode,
              item.itemName,
              selectedWarehouseTo,
              "TI",
              parseCurrency(item.itemQty),
              whDocId,
              newMaxTns,
              "เริ่มต้นประวัติคลัง", // 👈 คลังปลายทางมักจะเป็นการเริ่มต้น
              formMasterList.whDocRemark
            );

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-wh-doc-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);
          await handleUploadAttachments(whDocId);
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    console.debug("Begin handleUpdate");
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: formMasterList.whDocNo,
        wh_doc_status: parseCurrency("13", 10),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  return (
    <>
      <Breadcrumbs
        page={whDocNo}
        items={[
          { name: "คลังสินค้า", url: "/Warehouse" },
          { name: "จัดการเอกสารงานคลัง", url: "/treasury-documents" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />

      <div className="body" style={{ maxHeight: "75vh", overflowY: "auto" }}>
        <div class="container-fluid my-4">
          <div className="row mb-1">
            <div className="col-4">
              <div className="d-flex">
                <label>วันที่เอกสาร : </label>
                <Datetime
                  className="input-spacing-input-date"
                  name="whDocDate"
                  value={formMasterList.whDocDate || null}
                  onChange={(date) => handleChangeDateMaster(date, "whDocDate")}
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  inputProps={{ readOnly: true, disabled: mode === "U" }}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>ผู้ขาย</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="whDocCustId"
                    value={
                      (formMasterList.whDocCustCode || "") +
                      " " +
                      (formMasterList.whDocCustName || "")
                    }
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleApShow}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <ApModal
                    showApModal={showApModal}
                    handleApClose={handleApClose}
                    apDataList={apDataList}
                    onRowSelectAp={onRowSelectAp}
                  />
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label className="">วันที่สร้าง : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.whDocCreatedDate}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mb-1">
            <div className="col-4">
              <div className="d-flex">
                <label>วันที่จัดส่ง : </label>
                <Datetime
                  className="input-spacing-input-date"
                  name="whDocTransDate"
                  value={formMasterList.whDocTransDate || null}
                  onChange={(date) =>
                    handleChangeDateMaster(date, "whDocTransDate")
                  }
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  inputProps={{ readOnly: true, disabled: false }}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>จากคลัง : </label>
                <select
                  class="form-select"
                  value={selectedWarehouseFrom}
                  onChange={(e) =>
                    handleChangeWarehouse(e.target.value, "FROM")
                  }
                >
                  <option value={null}>กรุณาระบุคลัง</option>
                  {whDataList.map((warehouse) => (
                    <option key={warehouse.WH_Id} value={warehouse.WH_Id}>
                      {warehouse.WH_Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>สร้างโดย : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.whDocCreatedBy}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mb-1">
            <div className="col-4">
              <div className="d-flex">
                <label>หมายเหตุ : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="whDocRemark"
                  value={formMasterList.whDocRemark || ""}
                  onChange={handleChangeMaster}
                  disabled={false}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>ไปคลัง :</label>
                <select
                  class="form-select"
                  value={selectedWarehouseTo}
                  onChange={(e) => handleChangeWarehouse(e.target.value, "TO")}
                >
                  <option value={null}>กรุณาระบุคลัง</option>
                  {whDataList.map((warehouse) => (
                    <option key={warehouse.WH_Id} value={warehouse.WH_Id}>
                      {warehouse.WH_Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-4" />
          </div>
          <hr />
        </div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col-12">
              <ItemWhTable
                mode={mode}
                showItemModal={showItemModal}
                handleItemClose={handleItemClose}
                itemDataList={itemDataList}
                onRowSelectItem={onRowSelectItem}
                formDetailList={formDetailList}
                handleItemShow={handleItemShow}
                handleQuantityChange={handleQuantityChange}
                handleFocus={handleFocus}
                handleBlur={handleBlur}
                handleRemoveRow={handleRemoveRow}
                formatCurrency={formatCurrency}
                disabled={selectedWarehouseFrom === null}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
              />
            </div>
          </div>
        </div>
      </div>
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        mode={mode}
        disabled={false}
        footer={true}
      />
    </>
  );
};

export default FormTransfer;
